import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AOS from "aos";
import 'aos/dist/aos.css';

const ActionButtonCard = ({ delay, icon, text, onClick, to, label, footer, span, col }) => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
      mirror: false,
    });
  }, []);

  return (
    <div className={`${col || "col"} text-center`} data-aos="fade-up" data-aos-delay={delay}>
      <Link 
        to={to || "#"} 
        onClick={(e) => {
          e.preventDefault(); // evita que o Link faça a navegação padrão
          if (onClick) onClick(e);
          if (to) navigate(to); // navegação programática
        }} 
        className="btn card border"
      >
        <div>
          <span className={`${icon}`} style={{ fontSize: '2em' }}>{span}</span>
        </div>
        <small className="text-muted">{text}</small>
        <h5 className="mb-1">{label}</h5>
      </Link>
      <small className="text-muted">{footer}</small>
    </div>
  );
}

export default ActionButtonCard;